export default "__VITE_ASSET__fbfd99fe__"